import type { Locale } from "@/i18n-config";

/**
 * Routes whose last segment is written per language, so the same address in the other language is a 404: a blog
 * article (each language has its own articles and slugs). Switching language there goes to that language's blog —
 * the nearest page that exists (a link to a 404 was a broken internal link to every crawler).
 * The blog index and a category (`/blogs/category/…`) exist in both and keep their place.
 */
const PER_LANGUAGE = /^\/(fa|en)\/blogs\/(?!category(?:\/|$))[^/]+\/?$/;

/** Keep the current route when switching the document language — except where it has no twin (see above). */
export function localePath(pathname: string | null, locale: Locale): string {
  if (!pathname || pathname === "/") return `/${locale}`;
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  if (PER_LANGUAGE.test(path)) return `/${locale}/blogs`;
  return /^\/(fa|en)(?=\/|$)/.test(path)
    ? path.replace(/^\/(fa|en)(?=\/|$)/, `/${locale}`)
    : `/${locale}${path}`;
}
